import React from 'react';
import { useIntl } from 'react-intl';
import { LeftOutlined } from '@ant-design/icons';
import type { CategoryConfig, CategoryQuestionNode } from '../../types/category';
import QuestionSelectBody from './shared/QuestionSelectBody';

interface ThemeColors {
  background: string;
  text: string;
  cardBg?: string;
}

interface UCQuestionPageProps {
  categoryConfig: CategoryConfig;
  options: CategoryQuestionNode[];
  colors: ThemeColors;
  onBack: () => void;
  onSelect: (node: CategoryQuestionNode) => void;
  onSelectOther: () => void;
}

const UCQuestionPage: React.FC<UCQuestionPageProps> = ({
  categoryConfig,
  options,
  colors,
  onBack,
  onSelect,
  onSelectOther,
}) => {
  const intl = useIntl();
  const cardBg = colors.cardBg || '#ffffff';

  return (
    <div
      style={{
        minHeight: '100vh',
        background: colors.background,
        color: colors.text,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', padding: '12px 8px 0' }}>
        <button
          type="button"
          onClick={onBack}
          style={{
            border: 'none',
            background: 'transparent',
            color: colors.text,
            cursor: 'pointer',
            padding: 8,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <LeftOutlined style={{ fontSize: 18 }} />
        </button>
        <div style={{ fontSize: 16, fontWeight: 600, marginLeft: 4 }}>
          {intl.formatMessage({
            id: 'v2.customer_support',
            defaultMessage: 'Customer Support',
          })}
        </div>
      </div>
      <QuestionSelectBody
        categoryConfig={categoryConfig}
        options={options}
        vars={{
          cardBg,
          text: colors.text,
          textSecondary: 'color-mix(in srgb, currentColor 58%, transparent)',
          border: 'color-mix(in srgb, currentColor 12%, transparent)',
          accent: '#1677ff',
          hoverBg: 'color-mix(in srgb, currentColor 6%, transparent)',
        }}
        onSelect={onSelect}
        onSelectOther={onSelectOther}
      />
    </div>
  );
};

export default UCQuestionPage;
